import { estadoPadronInfo } from '@lib/estado-padron';
import type { TonoEstado } from '@lib/estado-legajo';

const TONO_CLASS: Record<TonoEstado, string> = {
  success: 'status status-success',
  info: 'status status-info',
  warning: 'status status-warning',
  error: 'status status-error',
  neutral: 'status',
};

/**
 * Badge del estado del PADRÓN, con el label del catálogo y la descripción como
 * tooltip. Mismo molde que `EstadoLegajoBadge` — antes la tabla de Padrones
 * pintaba el estado crudo con un ternario cerrado/no-cerrado, así que
 * `borrador` y `pendiente_validacion` salían del mismo color.
 */
export function EstadoPadronBadge({ estado, size = 11 }: { estado: string; size?: number }) {
  const info = estadoPadronInfo(estado);
  const neutral = info.tono === 'neutral';
  return (
    <span
      className={TONO_CLASS[info.tono]}
      title={info.descripcion}
      style={{
        fontSize: size,
        cursor: 'help',
        whiteSpace: 'nowrap',
        textTransform: 'none',
        ...(neutral
          ? { background: 'var(--color-surface-accent, #eef1f5)', color: 'var(--color-element-mid)' }
          : {}),
      }}
    >
      {info.label}
    </span>
  );
}
